define([
    "jquery",
    "underscore",
    "marionette",
    "swiper"
], function($, _, Marionette, Swiper) {
    return Marionette.View.extend({
        el: '#footer_layout',

        initialize: function(){
            this.bindUIElements();

            new Swiper('.swiper-container', {
                slidesPerView: 7,
                initialSlide: 7,
                noSwiping: true,
                autoplayDisableOnInteraction: false,
                loop: true,
                autoHeight: true,
                autoplay: 1500
            });
        }
    });
});